export interface TaskTakeFiveQuestions {
    key: string,
    value: string,
    altValue?: string,
    tooltip?: string
}

const TaskTakeFiveQuestions = {
    locationId: {
        key: 'locationId',
        value: 'Location'
    },
    otherLocation: {
        key: 'otherLocation',
        value: 'Other Location'
    },
    taskName: {
        key: 'taskName',
        value: 'Task Name'
    },
    taskScopeUnderstood: {
        key: 'taskScopeUnderstood',
        value: 'Do you understand task scope?',
        id: 1.1,
        section: 1
    },
    procedureExist: {
        key: 'procedureExist',
        value: 'Does the procedure exist?',
        id: 1.2,
        section: 1
    },
    taskStepsUnderstood: {
        key: 'taskStepsUnderstood',
        value: 'Do you understand the steps required to do the task?',
        id: 1.3,
        section: 1
    },
    areToolsAndEquipmentsInGoodOrder: {
        key: 'areToolsAndEquipmentsInGoodOrder',
        value: 'Are tools and equipment in good order?',
        id: 1.4,
        section: 1
    },
    correctPPE: {
        key: 'correctPPE',
        value: 'Do you have the correct PPE?',
        id: 1.5,
        section: 1
    },
    necessaryPermits: {
        key: 'necessaryPermits',
        value: 'Do you have the necessary permits?',
        id: 1.6,
        section: 1
    },
    clearPlan: {
        key: 'clearPlan',
        value: 'Have you got a clear plan in mind?',
        id: 1.7,
        section: 1
    },
    canRiskToHandsBeEliminated: {
        key: 'canRiskToHandsBeEliminated',
        value: 'Can this job be carried out in a way that eliminates the risk to your hands altogether or engineers it out?',
        id: 1.8,
        section: 1
    },
    handsPlacedInVicinity: {
        key: 'handsPlacedInVicinity',
        value: 'Will my hands be placed in the vicinity or on a moving object or in a pinch/crush point?',
        id: 2.1,
        section: 2
    },
    equipmentGuardseRemoved: {
        key: 'equipmentGuardseRemoved',
        value: 'Will I be operating equipment with the guards removed?',
        id: 2.2,
        section: 2
    },
    mobileEquipmentRisk: {
        key: 'mobileEquipmentRisk',
        value: 'Am I or others at risk from the operation of the vehicles or mobile equipment?',
        id: 2.3,
        section: 2
    },
    areHazardousMaterialsInvloved: {
        key: 'areHazardousMaterialsInvloved',
        value: 'Does the task involve hazardous materials?',
        id: 2.4,
        section: 2
    },
    taskPerformedWithoutIsolationProcedure: {
        key: 'taskPerformedWithoutIsolationProcedure',
        value: 'Will I be performing a task without specific isolation procedure?',
        id: 2.5,
        section: 2
    },
    workingAtHeights: {
        key: 'workingAtHeights',
        value: 'Will I be working at heights?',
        id: 2.6,
        section: 2
    },
    impactedByOtherActivity: {
        key: 'impactedByOtherActivity',
        value: 'Will I be impacted by other activities in the vicinity?',
        id: 2.7,
        section: 2
    },
    environmentalHnSHazards: {
        key: 'environmentalHnSHazards',
        value: 'Other environment and / or H&S hazard?',
        id: 2.8,
        section: 2
    },
    hazard: {
        key: 'hazard',
        value: 'Hazard:'
    },
    riskType: {
        key: 'riskType',
        value: 'Risk Type:'
    },
    control: {
        key: 'control',
        value: 'Control:'
    },
    riskScore: {
        key: 'riskScore',
        value: 'Risk Score:'
    },
    risk: {
        key: 'risk',
        value: 'Select Risk Type Above'
    },
    otherHazard: {
        key: 'otherHazard',
        value: 'Enter other hazard:'
    },
    dateCreated: {
        key: 'dateCreated',
        value: 'Date created'
    },
    createdBy: {
        key: 'createdBy',
        value: 'Created by'
    }
}

export default TaskTakeFiveQuestions;